<span fxLayout="column" fxLayoutGap="20px">
  <span fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="center start"
    class="overflow-hidden m-0">
    <span fxLayout="column" fxFill fxFlex="0 1 900px" fxFlex.sm="100" fxFlex.xs="100" class="position-relative">
      <span fxLayout="column" fxLayoutGap="20px" fxFlex.xs="100" fxFlex="100" fxFill
        class="res-img-height506-width100 image-ratio-container">
        <img *ngIf="picture" width="100%" class="object-fit-cover absolute-zero" [src]="picture | safe: 'resourceUrl'"
          (error)="onImgError()" />
      </span>
      <span fxLayout="column" class="position-absolute overlay-shade h-50 w-100 top-50"
        fxLayoutAlign="end space-between">
        <span fxLayout="row" fxLayoutAlign="end">
          <span fxLayout="column" fxFill fxLayoutAlign="end">
            <span class="px-3 pb-3" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end">
              <!-- <app-age-category-badge class="res-image-height-widht-58-36 res-margin-t-141-40" *ngIf="ytbesprechung.rating.id > 2" [ageCategory]="ytbesprechung.alter"></app-age-category-badge>
              <app-traffic-lights class="res-image-height-width-148-76x58-30 res-margin-t-141-40 res-pad-t-50-0 " [rating]="ytbesprechung.rating.id"></app-traffic-lights> -->

              <div fxFlex="10px"></div>
              <app-age-category-badge [ageCategory]="ytbesprechung?.alter" *ngIf="ytbesprechung?.rating?.id > 2"
                class="mt-auto res-image-height-widht-58-36" />
              <app-traffic-lights class="res-image-height-width-148-76x58-30 res-pad-t-50-0"
                [rating]="ytbesprechung?.rating.id"></app-traffic-lights>

            </span>
          </span>
        </span>
      </span>
    </span>
  </span>
  <span *ngIf="!loading" fxLayout="row" fxFill fxLayoutAlign="center start">
    <span fxLayout="column" fxFlex="0 1 900px" fxLayoutGap="10px">
      <span fxLayout="row"
        class="res-pad-lr-0-20 primary-color mat-headline-1 image-overline-gap overline-margin">{{'ytb.overline' |
        translate}}</span>
      <h1 fxLayout="row" class="res-pad-lr-0-20 mat-headline-2 overline-title-gap">{{ytbesprechung.title}}</h1>
      <div *ngIf="(ytbesprechung && ytbesprechung.published == false)">{{'redtext.unpublished' | translate}}</div>


      <app-ytb-detail-icon-list fxFlex class="mobile-only res-pad-lr-0-20 title-content-gap m-0"
        [ytbesprechung]="ytbesprechung"></app-ytb-detail-icon-list>


      <span fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="30px" fxLayoutAlign="start start"
        class="res-pad-lr-0-20 title-content-gap">

        <span fxLayout="column" class="rex-desktop-only-flex-576">
          <span fxLayout="row" class="mb1">{{ytbesprechung.content}}</span>

          <span class="flimmo-card flimmo-meint-box" fxLayout="row" *ngIf="ytbesprechung?.warnung">
            <span fxLayout="column" fxLayoutGap="20px">
              <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="25px">
                <div fxFlex="22px">
                  <mat-icon class="icon-warning">error_outline</mat-icon>
                </div>
                <span class="mb2">{{ytbesprechung?.warnung}}</span>
              </span>
            </span>
          </span>

          <span *ngIf="ytbesprechung.grue.length > 0" class="flimmo-card flimmo-meint-box" fxLayout="column"
            fxLayoutGap="10px">
            <span fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" class=" mat-subtitle-2">
              <mat-icon class="greentext-color">circle</mat-icon><span>Grün</span>

            </span>
            <span fxLayout="column" fxLayoutGap="20px" fxFlexOffset="15px">
              <span fxLayout="column" *ngFor="let p of ytbesprechung.grue">
                <span class="mb2">{{p.name}}</span>
                <span class="mb1">{{p.description}}</span>
              </span>
            </span>
          </span>

          <span *ngIf="ytbesprechung.gelb.length > 0" class="flimmo-card flimmo-meint-box" fxLayout="column"
            fxLayoutGap="10px">
            <span fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" class=" mat-subtitle-2">
              <mat-icon class="mat-warning">circle</mat-icon><span>Gelb</span>
            </span>
            <span fxLayout="column" fxLayoutGap="20px" fxFlexOffset="15px">
              <span fxLayout="column" *ngFor="let p of ytbesprechung.gelb">
                <span class="mb2">{{p.name}}</span>
                <span class="mb1">{{p.description}}</span>
              </span>
            </span>
          </span>

          <span *ngIf="ytbesprechung.rot.length > 0" class="flimmo-card p20px" fxLayout="column" fxLayoutGap="10px"
            fxFlexOffset="20px">
            <span fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" class=" mat-subtitle-2">
              <mat-icon class="mat-danger">circle</mat-icon><span>Rot</span>
            </span>
            <span fxLayout="column" fxLayoutGap="20px" fxFlexOffset="15px">
              <span fxLayout="column" *ngFor="let p of ytbesprechung.rot">
                <span class="mb2">{{p.name}}</span>
                <span class="mb1">{{p.description}}</span>
              </span>
            </span>
          </span>

          <span fxLayout="row" fxLayoutAlign="center" fxFlexOffset="15px" class="py-40px">
            <button fxFlex="1 1 210px" fxLayout="row" fxFlexAlign="center center" (click)="openLegend()"
              class="align-items-center justify-content-center flimmo-outline-button f-button-label text-decoration-none black">{{'besprechung.flimmoButton'
              | translate}}</button>
          </span>


          <span *ngIf="ytbesprechung.imagec" fxLayout="row" fxLayoutGap="10px" class="opaquetexts-color"
            fxFlexOffset="20px" fxLayoutAlign="start center">
            <span fxLayout="column">
              <span class="f-copyright">{{'common.copyrightTitle' | translate}}</span>
              <span class="f-copyright-text">{{this.ytbesprechung?.imagec}}</span>
            </span>
          </span>
        </span>

        <app-ytb-detail-icon-list class="desktop-only" [ytbesprechung]="ytbesprechung"></app-ytb-detail-icon-list>

      </span>
    </span>
  </span>
  <span fxFlex="50px"></span>
</span>